import React, { useState } from "react";
import Image from "next/image";
import PropTypes from "prop-types";

function CollapseClose({ question, answer }) {
  const [isAnsVisible, setIsAnsVisible] = useState(false);

  const toggleAnsVisibility = () => {
    if (isAnsVisible) setIsAnsVisible(false);
    else setIsAnsVisible(true);
  };

  return (
    <div className="py-[2rem] border-b-[1px] border-[#CBD0D6]">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={toggleAnsVisibility}
      >
        <h4 className="text-[1.25rem] leading[2rem]">{question}</h4>

        <div className="min-w-[14px] ml-[1.625rem]">
          <Image
            src={`${
              isAnsVisible
                ? "/assets/icons/red-minus.svg"
                : "/assets/icons/red-plus.svg"
            }`}
            width={14}
            height={14}
            alt="auth-image"
          />
        </div>
      </div>
      <div className={`${isAnsVisible ? "" : "hidden"}`}>
        <p className="text-grayD3 text-body1 mt-[1.5rem]">{answer}</p>
      </div>
    </div>
  );
}

export default CollapseClose;

CollapseClose.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
};
